import React from "react";

const Chapter4 = () => {
  return (
    <>
      <h2>Regulation</h2>
      <p>
        The Clean Water Act (CWA), which was established in 1948 and then
        expanded in 1972, regulates pollutants and sets up water quality
        standards. In addition to national standards, Colorado implements their
        own standards and enforces their permitting programs. The Colorado
        Department of Public Health and the Environment (CDPHE) Water Quality
        Control Division oversees these water control and enforcement programs.
        The primary source of regulation is the Colorado Water Quality Control
        Act, which dictates that water quality regulations must be at least as
        high as federal requirements. There are water quality requirements for
        both drinking water and surface water standards.
      </p>
    </>
  );
};

export default Chapter4;
